(ns app.front.view.common.data-grid
  (:require [app.front.util :as futil]))

(def header-label :div.text-sm.text-ui-night-sky-100.font-bold.mb-2)

(defn grid-item [{:keys [label class]} & content]
  (into [:div.ws-info {:class class}
         (when label [header-label label])]
        content))

(defn grid-item-tall [label content]
  [grid-item {:label label
              :class "min-h-20"}
   content])

(defn data-grid [& grid-items]
  [:div.grid.grid-cols-1.md:grid-cols-2.lg:grid-cols-5.gap-2
   (futil/for-frag [item grid-items]
     item)])
